import { ErrorText, RequiredSpan } from '../TextFieldAtom/TextFieldAtom.styled';
import {
    CheckBox,
    StyledCheckboxLabel,
    TextLabel,
} from './CheckboxAtom.styled';

export interface DumbCheckboxAtomI {
    /** Indicates if an error exists for this field */
    hasError: boolean;

    /** The id from the registration config, to be used as name/id of the field */
    id: string;

    /** Display label for the field */
    label: string;

    /** Whether the field is required to continue */
    required: boolean;

    /** Callback to trigger to update the value managed by the form */
    updateField: (value: boolean) => void;

    /** The current value of the field, managed by the form */
    value: boolean;

    /** Error message to be displayed below each field */
    errorText?: string;
}

const DumbCheckboxAtom = ({
    hasError,
    id,
    label,
    required,
    updateField,
    value,
    errorText,
}: DumbCheckboxAtomI) => (
    <StyledCheckboxLabel hasError={hasError} htmlFor={id}>
        <CheckBox
            type="checkbox"
            id={id}
            name={id}
            checked={value}
            onChange={(e) => updateField(e.target.checked)}
        />
        <TextLabel>
            {label} {required && <RequiredSpan>*</RequiredSpan>}
        </TextLabel>
        {hasError && errorText && <ErrorText>{errorText}</ErrorText>}
    </StyledCheckboxLabel>
);

export default DumbCheckboxAtom;
